import React from "react";
import { Link } from "react-router-dom";

interface Props {
  title: string;
  link: string;
  img: string;
  desc: string;
}

const Item = (props: Props) => {
  return (
    <Link className="item" to={props.link}>
      <img src={props.img} alt={props.title} />
      <div className="title">{props.title}</div>
      <div className="desc">{props.desc}</div>
    </Link>
  );
};

export default Item;
